import React from 'react'
import Register from '../components/Register'
//file renders Registration 
const Registerpage = () => {
    return (
        <div>
          
            <Register />
            
        </div>
    )
}

export default Registerpage
